/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const checkedUrlParams = () => {
  const { history } = window;
  // for user
  const allBtn = document.querySelectorAll('.js-short-btn-filter');
  allBtn.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      allBtn.forEach(btn1 => {
        btn1.classList.remove('is-active');
      });
      e.currentTarget.classList.add('is-active');
      const basicUrl = e.currentTarget.getAttribute('data-basic-url');
      const href = e.currentTarget.getAttribute('href');
      const markerSe = href
        .replace(basicUrl, '')
        .replaceAll('/', '-')
        .slice(0, -1);
      const displaySe = document.querySelectorAll('.inner-content-js');
      displaySe.forEach(se => {
        se.classList.remove('is-active');
        if (se.id === markerSe) {
          se.classList.add('is-active');
          // basicUrl += markerSe;
          // history.pushState({ page: e.target.value }, 'title 1', basicUrl);
          history.replaceState({ page: e.target.value }, 'title 1', href);
          const allForm = document.querySelectorAll('.filter-form-js');
          allForm.forEach(form => {
            form.querySelectorAll('input').forEach(input => {
              const changeChecked = input;
              changeChecked.checked = false;
            });
            form.querySelectorAll('.single-option-groups').forEach(group => {
              group.classList.add('is-hidden');
            });
            const groupOption = form.querySelectorAll('.single-option-groups');
            const paramsUrl =
              window.location.protocol + form.getAttribute('data-basic-url');
            const currentUrl = window.location.href;
            const currentParam = currentUrl.replace(paramsUrl, '').split('/');

            groupOption.forEach((group, key) => {
              const marker = group.getAttribute('data-mark');
              group.classList.add('is-hidden');
              if (currentParam) {
                currentParam.forEach((param, key2) => {
                  if (marker === param) {
                    group.classList.remove('is-hidden');
                  }
                  if (document.querySelector(`input[value="${param}"]`)) {
                    document.querySelector(
                      `input[value="${param}"]`,
                    ).checked = true;
                  }
                });
              }
            });
          });
          se.scrollIntoView(true);
        }
      });
    });
  });

  // for editor
  const allBtnsShort = document.querySelectorAll('.js-short-btn');
  allBtnsShort.forEach(btn => {
    btn.classList.remove('is-active');
    btn.addEventListener('click', e => {
      allBtnsShort.forEach(btn1 => {
        btn1.classList.remove('is-active');
      });
      e.currentTarget.classList.add('is-active');
      const btnMarker = e.currentTarget.getAttribute('data-marker');
      const displaySe = document.querySelectorAll('.inner-content-js');
      displaySe.forEach(se => {
        se.classList.remove('is-active');
        const allForm = document.querySelectorAll('.filter-form-js');
        allForm.forEach(form => {
          form.querySelectorAll('input').forEach(input => {
            const changeChecked = input;
            changeChecked.checked = false;
          });
          form.querySelectorAll('.single-option-groups').forEach(group => {
            group.classList.add('is-hidden');
          });
          const groupOption = form.querySelectorAll('.single-option-groups');
          const paramsUrl =
            window.location.protocol + form.getAttribute('data-basic-url');
          const currentUrl = window.location.href;
          const currentParam = currentUrl.replace(paramsUrl, '').split('/');

          groupOption.forEach((group, key) => {
            const marker = group.getAttribute('data-mark');
            group.classList.add('is-hidden');
            if (currentParam) {
              currentParam.forEach((param, key2) => {
                if (marker === param) {
                  group.classList.remove('is-hidden');
                }
              });
            }
          });
        });
        if (se.id === btnMarker) {
          se.classList.add('is-active');
        }
      });
    });
  });

  const menu = document.querySelector('.js-header');
  let offset = 0;
  if (menu) {
    offset = menu.getBoundingClientRect().height;
  }

  const allBtnBack = document.querySelectorAll('.js-back-to-top');
  allBtnBack.forEach(btn => {
    btn.addEventListener('click', e => {
      const target = document.getElementById(e.target.dataset.id);
      if (target) {
        const targetForm = target.parentElement.parentElement.querySelector(
          '.filter-form-js',
        );
        if (targetForm) {
          window.scrollTo(
            0,
            targetForm.getBoundingClientRect().top + window.scrollY - offset,
          );
        }
      }
    });
  });
};

export default checkedUrlParams;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/checkedUrlParams.js